import { render, staticRenderFns } from "./UserRecordTable.vue?vue&type=template&id=3d0a61c6&"
import script from "./UserRecordTable.vue?vue&type=script&lang=js&"
export * from "./UserRecordTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports